import { computed, ref } from 'vue';
import { SYSTEM_ASIDES } from './constants';

const activeAside = ref('');
const activeAsideProps = ref();
const asideVisibility = ref(false);
const currentRowId = ref();
const baseStyles = ['w-full sm:w-[450px] lg:w-[600px] 2xl:w-[900px]'];
const receiptsStyles = ['w-full lg:w-[650px] 2xl:w-[910px]'];
// NOTE :: The voucher details are a short two-column list, so the panel stays narrow.
const voucherStyles = ['w-full sm:w-[420px] 2xl:w-[480px]'];
const styles = computed(() => {
  if (activeAside.value === SYSTEM_ASIDES.RECEIPTS_ASIDE) return receiptsStyles;
  if (activeAside.value === SYSTEM_ASIDES.VOUCHER_DETAILS_ASIDE) return voucherStyles;

  return baseStyles;
});

export default function () {
  function isCurrentAsideOpen(targetModal: SYSTEM_ASIDES) {
    return targetModal === activeAside.value;
  }

  function reset() {
    activeAside.value = '';
    activeAsideProps.value = '';
    asideVisibility.value = false;
    currentRowId.value = undefined;
  }

  return {
    activeAside,
    activeAsideProps,
    asideVisibility,
    currentRowId,
    styles,

    SYSTEM_ASIDES,

    isCurrentAsideOpen,
    reset,
  };
}
